import { t } from "i18next";
import * as yup from "yup";

export const evaluateSchoolValidation = () =>
  yup.object().shape({
    comment: yup
      .string()
      .min(3, t("offerContnet.valiation.mustNotBeLessThan3")!)
      .max(300, t("offerContnet.valiation.mustNotExceed300")!),
  });
